import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'type',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Type')}</strong>,
  type: 'string',
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Messagerie')}</strong>,
  type: 'string',
}]

export default React.memo(props => <Formulaire defaultObject={{
  type: 'email', libelle: undefined, actif: 1
}} title={EurestoI18n.t('commun:Messagerie')} columnSearch={'id'} form={<Template/>} module={Constants.module.CONFIGURATION} requete={Constants.donnee.messagerie} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/SuiviDossier/Messagerie/index.js